{
  "Accessibility Menu": "辅助功能菜单",
  "Reset settings": "重置设置",
  "Close": "关闭",
  "Content Adjustments": "内容调整",
  "Adjust Font Size": "调整字体大小",
  "Highlight Title": "标题高亮",
  "Highlight Links": "链接高亮",
  "Readable Font": "易读字体",
  "Color Adjustments": "色彩调整",
  "Dark Contrast": "高对比度（黑色）",
  "Light Contrast": "高对比度（白色）",
  "High Contrast": "高对比度",
  "High Saturation": "高饱和度",
  "Low Saturation": "低饱和度",
  "Monochrome": "单色",
  "Contrast": "对比度",
  "Invert Colors": "反转颜色",
  "Tools": "更多设置",
  "Reading Guide": "阅读尺",
  "Stop Animations": "停止闪动",
  "Big Cursor": "放大鼠标",
  "Increase Font Size": "增加字体大小",
  "Decrease Font Size": "减小字体大小",
  "Letter Spacing": "字母间距",
  "Line Height": "行距",
  "Font Weight": "字重",
  "Dyslexia Font": "阅读障碍字体",
  "Language": "语言",
  "Open Accessibility Menu": "打开辅助功能菜单",
  "Widget Settings": "组件设置",
  "Widget Position": "组件位置",
  "Top Left": "左上角",
  "Top Center": "顶部中央",
  "Top Right": "右上角",
  "Center Left": "中部偏左",
  "Center Right": "中部偏右",
  "Bottom Left": "左下角",
  "Bottom Center": "底部中央",
  "Bottom Right": "右下角",
  "Screen Reader": "屏幕阅读器",
  "Voice Navigation": "语音导航",
  "Custom Color": "自定义颜色",
  "Change the site's colors": "更改网站颜色",
  "Backgrounds": "背景",
  "Headings": "标题",
  "Contents": "内容",
  "Reset colors": "重置颜色",
  "Image Desaturation": "降低图像饱和度",
  "Search languages": "搜索语言",
  "No languages found": "未找到任何语言",
  "Accessibility Profiles": "无障碍配置",
  "Motor Impaired": "运动障碍",
  "Big cursor, voice navigation, and no animations.": "大光标、语音导航并禁用动画。",
  "Blind": "视障用户",
  "Screen reader helpers with higher contrast.": "更高对比度的读屏辅助。",
  "Color Blind": "色盲模式",
  "High contrast palette with desaturated media.": "高对比度调色板与去饱和媒体。",
  "Dyslexia": "阅读障碍",
  "Friendly font, extra spacing, stronger weight.": "友好字体、额外行距与更粗字重。",
  "Low vision": "低视力",
  "Dark contrast and 130% magnification.": "深色对比与 130% 放大。",
  "Cognitive & Learning": "认知与学习",
  "Highlights key sections and enables voice help.": "突出关键区域并启用语音辅助。",
  "Seizure & Epileptic": "防癫痫模式",
  "Stops animations and desaturates imagery.": "停止动画并降低图像饱和度。",
  "ADHD": "多动症",
  "Reading guide, highlighted links, calmer palette.": "阅读引导、突出链接与柔和配色。",
  "Widget Size": "组件大小",
  "Default": "默认",
  "Medium": "中",
  "Small": "小",
  "Color Blindness": "色盲模拟",
  "Protanopia": "红色盲",
  "Deuteranopia": "绿色盲",
  "Tritanopia": "蓝色盲",
  "Achromatopsia": "全色盲",
  "Simulates and assists users with color vision deficiencies.": "模拟并协助色觉障碍用户。"
}
